import { useState, useEffect } from "react";
import axios from "axios";

// Fallback languages if API fails
const fallbackLanguages = [
  {
    id: "c5405135-2871-4aa7-b150-a90df089e590",
    code: "en",
    name: "English",
    created_at: "2025-09-03T12:46:35.087307Z",
    updated_at: "2025-09-03T12:46:35.087307Z",
  },
  {
    id: "c517414a-73f7-4c92-932c-ce45de7f9976",
    code: "fr",
    name: "Français",
    created_at: "2025-09-03T12:46:35.087307Z",
    updated_at: "2025-09-03T12:46:35.087307Z",
  },
  {
    id: "59bbe7b6-689f-4842-81c5-ac45d2b270bc",
    code: "nl",
    name: "Nederlands",
    created_at: "2025-09-03T12:46:35.087307Z",
    updated_at: "2025-09-03T12:46:35.087307Z",
  },
  {
    id: "9bec903c-caec-49c0-aa0a-095bdd2ea868",
    code: "tr",
    name: "Türkçe",
    created_at: "2025-09-03T12:46:35.087307Z",
    updated_at: "2025-09-03T12:46:35.087307Z",
  },
  {
    id: "93d9cd20-7745-4cd4-bb32-20eb7fdbb921",
    code: "de",
    name: "Deutsch",
    created_at: "2025-09-03T12:46:35.087307Z",
    updated_at: "2025-09-03T12:46:35.087307Z",
  },
  {
    id: "77c800e7-d8ce-4f8c-ae6e-0de4e8dec1f0",
    code: "es",
    name: "Español",
    created_at: "2025-09-03T12:46:35.087307Z",
    updated_at: "2025-09-03T12:46:35.087307Z",
  },
  {
    id: "21bc03b8-3bc7-4edf-b1b5-238a55c92519",
    code: "pt",
    name: "Português",
    created_at: "2025-09-03T12:46:35.087307Z",
    updated_at: "2025-09-03T12:46:35.087307Z",
  },
  {
    id: "25f6f4b1-b589-46c6-b34a-20c47406608f",
    code: "it",
    name: "Italiano",
    created_at: "2025-09-03T12:46:35.087307Z",
    updated_at: "2025-09-03T12:46:35.087307Z",
  },
];

// Flag emojis for each language code
const languageFlags = {
  en: "🇺🇸",
  fr: "🇫🇷",
  nl: "🇳🇱",
  tr: "🇹🇷",
  de: "🇩🇪",
  es: "🇪🇸",
  pt: "🇵🇹",
  it: "🇮🇹",
};

export default function useGetSupportedLanguages() {
  const [languageOptions, setLanguageOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSupportedLanguages = async () => {
      try {
        setIsLoading(true);
        setError(null);

        // Get the base URL from environment variables (same as api.js)
        const baseURL =
          import.meta.env.VITE_API_BASE_URL ?? "https://api-dev.sospita.io";

        const response = await axios.get(
          `${baseURL}/api/v1/metadata/supported-languages`,
          {
            timeout: 5000, // 5 second timeout
          }
        );

        const supportedLanguages = response.data || fallbackLanguages;

        // Transform languages data into options format
        const languages = supportedLanguages.map((lang) => ({
          value: lang.code,
          label: `${languageFlags[lang.code] || ""} ${lang.name}`,
          name: lang.name,
          id: lang.id,
        }));

        // Sort languages with English first, then alphabetically
        const sortedLanguages = languages.sort((a, b) => {
          if (a.value === "en") return -1;
          if (b.value === "en") return 1;
          return a.name.localeCompare(b.name);
        });

        setLanguageOptions(sortedLanguages);
      } catch (err) {
        console.warn(
          "Failed to fetch supported languages, using fallback:",
          err
        );
        setError(err);

        // Use fallback languages
        const languages = fallbackLanguages.map((lang) => ({
          value: lang.code,
          label: `${languageFlags[lang.code] || ""} ${lang.name}`,
          name: lang.name,
          id: lang.id,
        }));

        const sortedLanguages = languages.sort((a, b) => {
          if (a.value === "en") return -1;
          if (b.value === "en") return 1;
          return a.name.localeCompare(b.name);
        });

        setLanguageOptions(sortedLanguages);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSupportedLanguages();
  }, []);

  return {
    languageOptions,
    error,
    isLoading,
  };
}
